import React from 'react';
import { Card, CardContent } from './../ui/card';
import { Button } from './../ui/button';
import { Badge } from './../ui/badge';
import { Pencil, Trash2, User, Briefcase } from 'lucide-react';
import { motion } from 'framer-motion';

const avatarColors = {
  blue: 'from-blue-500 to-cyan-500',
  purple: 'from-purple-500 to-pink-500',
  green: 'from-emerald-500 to-teal-500',
  orange: 'from-orange-500 to-amber-500',
  red: 'from-red-500 to-rose-500',
  indigo: 'from-indigo-500 to-blue-500'
};

export default function MemberCard({ member, onEdit, onDelete }) {
  const colorGradient = avatarColors[member.avatar_color] || avatarColors.blue;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <Card className="bg-white border-2 border-slate-100 hover:border-blue-300 hover:shadow-lg hover:shadow-blue-100/50 transition-all duration-300 overflow-hidden">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            {/* Avatar */}
            <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${colorGradient} flex items-center justify-center shadow-lg ring-4 ring-white shrink-0`}>
              <span className="text-2xl font-bold text-white">
                {member.name.charAt(0).toUpperCase()}
              </span>
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <h3 className="font-bold text-slate-900 text-lg mb-1 truncate">
                {member.name}
              </h3>
              <div className="flex items-center gap-2 mb-2">
                <Briefcase className="w-3.5 h-3.5 text-slate-400" />
                <span className="text-sm text-slate-600 font-medium">{member.profession}</span>
              </div>
              {member.email && (
                <p className="text-xs text-slate-500 truncate">{member.email}</p>
              )}
              <div className="mt-3">
                {member.active ? (
                  <Badge className="bg-emerald-100 text-emerald-700 shadow-sm font-semibold">
                    Ativo
                  </Badge>
                ) : (
                  <Badge className="bg-slate-100 text-slate-600 shadow-sm font-semibold">
                    Inativo
                  </Badge>
                )}
              </div>
            </div>

            {/* Actions */}
            <div className="flex flex-col gap-2">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(member)}
                className="h-8 w-8 text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg"
              >
                <Pencil className="w-4 h-4" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onDelete(member.id)}
                className="h-8 w-8 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}